import React, { useEffect, useState } from "react";
import { AdminLayout } from "@/components/AdminLayout";
import api from "@/lib/api";
import { toast } from "sonner";
import PreviewMenuView from "@/components/menu/PreviewMenuView";
import { loadCustomerExperience } from "@/lib/customerExperience";

const getBusinessSubDomain = (user = {}) =>
  user.businessSubDomain ??
  user.BusinessSubDomain ??
  user.subDomain ??
  user.SubDomain ??
  "";

const getBusinessName = (user = {}) =>
  user.businessName ||
  user.business_name ||
  user.businessName ||
  user.name ||
  user.business?.name ||
  "";

const getBusinessLogo = (user = {}) =>
  user.logo_url ||
  user.logoUrl ||
  user.businessLogo ||
  user.business?.logo_url ||
  user.business?.logoUrl ||
  "";

const normalizePromotions = (promotions = []) =>
  promotions.map((promotion) => {
    const rawProducts = promotion.products ?? promotion.Products ?? [];

    const selectedProductIds =
      promotion.productIds ??
      promotion.ProductIds ??
      promotion.selectedProductIds ??
      promotion.SelectedProductIds ??
      rawProducts.map((product) => product.id ?? product.Id) ??
      [];

    return {
      id: promotion.id ?? promotion.Id,
      title: promotion.name ?? promotion.Name ?? "",
      description: promotion.description ?? promotion.Description ?? "",
      image_url:
        promotion.image_url ??
        promotion.imageUrl ??
        promotion.ImageUrl ??
        promotion.imageFile?.fileUrl ??
        promotion.ImageFile?.fileUrl ??
        "",
      imageId: promotion.imageId ?? promotion.ImageId ?? null,
      is_active: promotion.visible ?? promotion.Visible ?? true,
      selectedProductIds: Array.isArray(selectedProductIds)
        ? selectedProductIds.map((id) => String(id))
        : [],
      startDate: promotion.beginDate ?? promotion.BeginDate ?? "",
      endDate: promotion.endDate ?? promotion.EndDate ?? "",
      order:
        promotion.sortOrder ??
        promotion.SortOrder ??
        promotion.index ??
        promotion.Index ??
        0,
      raw: promotion,
    };
  });

export default function PreviewPage() {
  const [categories, setCategories] = useState([]);
  const [menuItems, setMenuItems] = useState([]);
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);

  const [businessInfo, setBusinessInfo] = useState({
    name: "",
    subDomain: "",
    logoUrl: "",
  });

  const [customerPopupData, setCustomerPopupData] = useState(null);

  useEffect(() => {
    const loadPreview = async () => {
      try {
        setLoading(true);

        const rawUser = localStorage.getItem("user");

        if (!rawUser) {
          toast.error("Kullanıcı bilgisi bulunamadı.");
          return;
        }

        const user = JSON.parse(rawUser);
        const businessSubDomain = getBusinessSubDomain(user);

        if (!businessSubDomain) {
          toast.error("Restoran alan adı bulunamadı.");
          return;
        }

        const businessRes = await api.getBusinessBySubDomain(
          businessSubDomain
        );

        const business = businessRes?.data || {};

        setBusinessInfo({
          name: business.name || getBusinessName(user),
          subDomain: business.subDomain || businessSubDomain,
          logoUrl: business.logo_url || getBusinessLogo(user),
        });

        setCustomerPopupData(loadCustomerExperience(businessSubDomain));

        const [promotionsRes, categoriesRes, productsRes] = await Promise.all([
          api.getPublicPromotions({
            businessSubDomain,
            page: 0,
            pageSize: 1000,
          }),

          api.getCategories({
            businessSubDomain,
            visible: true,
            page: 0,
            pageSize: 1000,
          }),

          api.getMenuItems({
            businessSubDomain,
            status: true,
            page: 0,
            pageSize: 1000,
          }),
        ]);

        setBanners(normalizePromotions(promotionsRes?.data || []));
        setCategories(categoriesRes?.data || []);
        setMenuItems(productsRes?.data || []);
      } catch (error) {
        console.error("Preview yüklenirken hata:", error);
        toast.error("Menü önizlemesi yüklenirken bir hata oluştu.");
      } finally {
        setLoading(false);
      }
    };

    loadPreview();
  }, []);

  return (
    <AdminLayout>
      <PreviewMenuView
        categories={categories}
        menuItems={menuItems}
        banners={banners}
        businessInfo={businessInfo}
        customerPopupData={customerPopupData}
        loading={loading}
        loadingText="Önizleme yükleniyor..."
        audience="admin"
      />
    </AdminLayout>
  );
}